import React from 'react';
import { useClickAway } from 'react-use';

import { useCXI } from 'modules/cxi/useCXI';

import { Container } from '../container';
import * as Styled from './StyledGuide';

const LINK_TO_MATERIAL =
    'https://drive.google.com/file/d/187UAYHRc61M5z2qS9t7wlv0QVJ0l8eni/view?usp=sharing';

export const Guide = () => {
    const { t } = useCXI();
    const { setModal } = useCXI();
    const containerRef = React.useRef(null);

    useClickAway(containerRef, () => {
        setModal(null);
    });

    return (
        <Styled.Guide ref={containerRef}>
            <Styled.Close onClick={() => setModal(null)}>
                <span className="icon far fa-times" aria-hidden="true" />
            </Styled.Close>
            <Container.Head>
                <span className="text">{t('menu.guide')}</span>
            </Container.Head>

            <Container.Body>
                <iframe
                    src="https://www.youtube-nocookie.com/embed/_Tlp8FWGC9M?controls=0"
                    title="Como começar a contribuir com Startups"
                />
            </Container.Body>

            <Container.Feet>
                <p>Para começar a utilizar, clique no botão Conhecer Startups.</p>

                <p>
                    Você será direcionado para uma página onde receberá sugestões de startups que se
                    adequam ao perfil que você selecionou ao ingressar no programa pela primeira
                    vez. Se acha que a startup não se adeque às necessidades da sua empresa, aperta
                    o botão “Não quero avaliar”.
                </p>

                <p>
                    Caso o card tenha chamado sua atenção e você tenha interesse em obter mais
                    informações sobre uma solução, clique em "Quero Avaliar". Você será
                    redirecionado para o perfil da startup e, se desejar conectar-se com ela, basta
                    clicar no botão “Avaliar Startup".
                </p>

                <p>
                    No card que surgirá, você pode indicar o potencial que visualiza na startup e
                    deixar um feedback, ou seja, dicas ou comentários com base em sua bagagem
                    profissional que ajudarão aquele pequeno negócio a chegar ainda mais longe.
                </p>

                <p>
                    Tendo avaliado a startup, você deve aguardar enquanto ela aponta a relevância do
                    feedback enviado. Quando sua contribuição é avaliada positivamente, você
                    receberá um ponto no seu contador do programa. Após isso, você poderá solicitar
                    Speed-Datings, reuniões de até 18 minutos que acontecem durante a Oiweek; ou
                    iniciar um processo de mentoria com a startup.
                </p>
                <a
                    href={LINK_TO_MATERIAL}
                    title="Entenda o programa através do material explicativo"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="icon far fa-fw fa-arrow-down" aria-hidden="true" />
                    <span className="text">
                        {'Entenda o programa através do material explicativo '}
                    </span>
                </a>
                <hr size="20px" color="0094f9" />
            </Container.Feet>
        </Styled.Guide>
    );
};
